
import {Component} from 'san';
import throttle from 'lodash.throttle';
import styles from './style/index.module.less';
import {inView} from '@/lib/utils/view';


export default class Audio extends Component {
    static template = require('./index.html');
    static computed = {
        itemData() {
            return this.data.get('data.data.original');
        }
    };

    initData() {
        return {
            styles,
            play: false,
            sendShowLog: false,
            supportAudio: true // audio标签支持度98.61%
        };
    }
    attached() {
        const supportAudio = this.checkAudio();
        if (!supportAudio) {
            this.data.set('supportAudio', false);
        }
        this.bindScrollEvent();
        this.bindAudioEvent();
    }
    bindScrollEvent() {
        const songid = this.data.get('itemData.media_id') || '';
        const fileDuration = this.data.get('itemData.file_duration') || '';
        if (inView(this.el)) {
            this.storeDispatch('audio:showLog', {songid, fileDuration});
            this.data.set('sendShowLog', true);
        } else {
            /* eslint-disable no-use-before-define */
            const sendShowLog = () => {
                if (inView(this.el) && !this.data.get('sendShowLog')) {
                    this.storeDispatch('audio:showLog', {songid, fileDuration});
                    this.data.set('sendShowLog', true);
                    window.removeEventListener('scroll', scrollFn);
                }
            };
            const scrollFn = throttle(sendShowLog, 500);
            if (!this.data.get('sendShowLog')) {
                window.addEventListener('scroll', scrollFn);
            }
        }
    }
    bindAudioEvent() {
        const songid = this.data.get('itemData.media_id') || '';
        const fileDuration = this.data.get('itemData.file_duration') || '';
        this.ref('audioPlayer').addEventListener('pause', () => {
            this.storeDispatch('audio:pauseLog', {songid, fileDuration});
        });
        this.ref('audioPlayer').addEventListener('play', () => {
            this.storeDispatch('audio:playLog', {songid, fileDuration});
            this.storeDispatch('tts:pause', {songid});
        });
        this.ref('audioPlayer').addEventListener('ended', () => {
            this.data.set('play', false);
        });
    }
    onClick() {
        const isPlaying = this.data.get('play');
        if (isPlaying) {
            this.data.set('play', false);
            this.ref('audioPlayer').pause();
        }
        else {
            this.data.set('play', true);
            this.ref('audioPlayer').play();
        }
    }
    checkAudio() {
        let audioTest = document.createElement('audio');
        // 如果不能播放，canPlayType返回''
        if (audioTest.canPlayType) {
            let mp4Test = !!audioTest.canPlayType('audio/mp4');
            let oggTest = !!audioTest.canPlayType('audio/ogg');
            let mpegTest = !!audioTest.canPlayType('audio/mpeg');
            return mpegTest || oggTest || mp4Test;
        }
        return false;
    }
    /* eslint-disable import/newline-after-import */
};

